// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gP","advertCardHeader__actions":"c-a_gQ","advertCardHeader__bottomLabel":"c-a_gR"};